<template>
  <Icon name="ads" :width="20" :height="20" :scale="25">
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 201.000000 201.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,201.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M767 1985 c-133 -37 -268 -109 -400 -216 -181 -145 -283 -304 -340
-529 -30 -121 -30 -339 0 -460 96 -379 379 -658 759 -746 119 -28 331 -26 449
5 111 28 277 107 328 154 72 69 82 56 -308 447 l-345 346 0 487 c0 474 -1 488
-20 507 -23 23 -54 24 -123 5z"
        />
        <path
          d="M1141 1971 c-21 -21 -21 -26 -21 -468 l0 -448 313 -312 c279 -280
316 -313 344 -313 38 0 64 30 116 135 272 544 -2 1199 -581 1394 -101 34 -146
37 -171 12z"
        />
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: "Ads",

  components: { Icon },
};
</script>
